(function() {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.ivr', {
            parent: 'settings',
            url: '/ivr',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            views: {
                'content@app': {
                    templateUrl: 'app/settings/ivr/ivr.html',
                    controller: 'IVRController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    //$translatePartialLoader.addPart('settings.ivr');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
